module.exports = __webpack_public_path__ + "static/media/card-tier.45219561.jpg";